import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { onAuthStateChanged, signOut, User } from "firebase/auth";
import { auth } from "../firebase/firebase";
import styles from "./Dashboard.module.css";

/**
 * Avatar: add your file as `public/user-avatar.avif` (see public/USER_AVATAR_README.txt).
 * Until then, the image errors and initials fallback is shown.
 */
const UserAvatar = () => {
  const [user, setUser] = useState<User | null>(auth.currentUser);
  const [imgBroken, setImgBroken] = useState(false);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, setUser);
    return () => unsub();
  }, []);

  const label = user?.displayName || user?.email || "Account";
  const initials = label
    .split(/\s+/)
    .map((s) => s[0])
    .join("")
    .slice(0, 2)
    .toUpperCase() || "?";

  return (
    <div className={styles.navmenu_right_item}>
      <button type="button" className={styles.userAvatarBtn} aria-label="Account">
        {!imgBroken ? (
          <img
            className={styles.userAvatarImg}
            src={`${process.env.PUBLIC_URL || ""}/user-avatar.avif`}
            alt=""
            onError={() => setImgBroken(true)}
          />
        ) : (
          <span className={styles.userAvatarFallback}>{initials}</span>
        )}
      </button>
      <span className={styles.name}>{label}</span>
    </div>
  );
};

const Navmenu = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth);
    } finally {
      navigate("/login", { replace: true });
    }
  };

  return (
    <div className={styles.navmenu}>
      <img height={65} src={`${process.env.PUBLIC_URL || ""}/logo.svg`} alt="TrustForge AI logo" />
      <div className={styles.navmenu_right}>
        <UserAvatar />
        <button
          type="button"
          className={styles.logoutBtn}
          onClick={handleLogout}
          aria-label="Log out"
        >
          <img height={22} src={`${process.env.PUBLIC_URL || ""}/Vector (2).svg`} alt="" />
        </button>
      </div>
    </div>
  );
};

export default Navmenu;
